import React from "react";
import styled from "styled-components";
import {isMobile} from 'react-device-detect';
import { Link } from "react-router-dom";

import Container from "./container"
import Buttons from "./buttons"

const Festival = styled.section`
    > div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: ${isMobile ? "wrap":"unset"};
        flex-flow: ${isMobile ? "column-reverse":"unset"};    
    }

    padding: 50px 10px;

    h3 {
        font-size: 42px;
        text-align: center;
        font-weight: bold;
        text-transform: uppercase;
        margin: 15px 0px;

        a {
            text-decoration: none;
            color: white;

            &:hover {
                text-decoration: underline;
            }
        }        
    }

    div.description {
        flex-basis: 35%;
        padding: 10px;
        line-height: 1.5em;

        img {
            display: block;
            width: 100%;
        }
    }

    .buttons {
        text-align: center;
    }
`
const Info = styled.div`
    display: ${isMobile ? "block":"flex"};
    justify-content: center;
    align-items: center;
    margin-bottom: 25px;

    font-size: 140%;
    text-align: center;
    font-weight: bold;

    span {
        display: ${isMobile ? "none":"inline-block"};
        margin: 0px 15px;
    }
`
const Shows = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    img {
        width: 150px;
        height: 200px;
    }
`
const Country = styled.div`
    text-align: center;
    text-transform: uppercase;
    padding: 5px;
`

function FestivalPreview({show}) {

  return (
    <Festival style={{backgroundColor: show.backgroundColor || "inherit"}}> 
        <Container>
            <div>
                <h3>
                    <Link to={show.url} style={{color: show.titleColor || "inherit"}}>
                        {show.title}
                    </Link>
                </h3>
                <Info style={{color: show.infoColor || "inherit"}}>
                    <div className="date">{show.dateFormatted}</div>
                    <span>|</span>
                    <div className="location">{show.location}</div>        
                </Info>
                {show.shows && 
                    <Shows>
                    {show.shows.map((show, index) => (
                        <div key={index}>
                            <Link to={"/show/" + show.name}>
                                <img src={show.poster} alt={show.title} />
                            </Link>
                            {show.country && <Country>{show.country}</Country>}
                        </div>
                    ))}
                    </Shows>
                }
                <Buttons show={show} more tickets />
            </div>   
            {show.description && 
                <div className="description">
                    {show.descriptionImageUrl && <img src={show.descriptionImageUrl} alt="" />}
                    <p dangerouslySetInnerHTML={{__html: show.description}} />
                </div>
            }
        </Container>
    </Festival>
  );
}

export default FestivalPreview;